import React,{ Component, Fragment } from "react";
import { browserHistory } from 'react-router';
import MealIcon from 'assets/select-meal.png';
import CalenderIcon from 'assets/select-calender.png';
import AddonIcon from 'assets/add-on.png';
import CheckoutIcon from 'assets/take-away.png';
class Tabs extends Component{

    constructor(props) {
        super(props);
    }

    renderTabList(){
        const { checkoutId } = this.props;
        const buttonText= (checkoutId!=undefined && checkoutId)?'Edit Meals':'Preset Meals';
        return <ul className="step-tabs customfit-tab">
            <li class="step-tab-list step-tab-active"><div class="step-list"><div class="step-list-top"><div class="step-indicator"><img src={MealIcon} /></div></div><div class="step-label">Select Main Meals  <br/>&amp; Build Combinations</div></div></li>
            <li class="step-tab-list step-tab-active"><div class="step-list"><div class="step-list-top"><div class="step-indicator"><img src={CalenderIcon} /></div></div><div class="step-label">Select <br/>No Of Days</div></div></li>
            <li class="step-tab-list step-tab-active" onClick={()=>{ if(checkoutId!=undefined && checkoutId) {browserHistory.push('/checkout/menus');}}}><div class="step-list"><div class="step-list-top"><div class="step-indicator"><img src={AddonIcon} /></div></div><div class="step-label">{buttonText}</div></div></li>
            <li class="step-tab-list step-tab-active"><div class="step-list"><div class="step-list-top"><div class="step-indicator"><img src={CheckoutIcon} /></div></div><div class="step-label">Checkout</div></div></li>
        </ul>;
    }

    render() {
        return <Fragment>
            {this.renderTabList()}
        </Fragment>;
    }
}
export default Tabs;